const services = [
  {
    title: "Hair Services",
    titleAr: "خدمات الشعر",
    href: "/services#hair",
    image:
      "https://public.readdy.ai/ai/img_res/8a284a4c1b6c6877facf7551391f4032.jpg",
  },
  {
    title: "Nail Services",
    titleAr: "خدمات الأظافر",
    href: "/services#nails",
    image:
      "https://readdy.ai/api/search-image?query=luxury%20nail%20art%20manicure%20close%20up%2C%20elegant%20woman%20hands%20with%20beautiful%20nail%20design%2C%20gold%20and%20nude%20tones%2C%20professional%20nail%20salon%20treatment%2C%20high-end%20beauty&width=600&height=400&seq=bm_svc002&orientation=landscape",
  },
  {
    title: "Facial & Skincare",
    titleAr: "علاجات الوجه والبشرة",
    href: "/services#facials",
    image:
      "https://readdy.ai/api/search-image?query=luxury%20facial%20treatment%20spa%2C%20woman%20receiving%20gold%20facial%20mask%20beauty%20treatment%2C%20relaxing%20spa%20environment%2C%20glowing%20radiant%20skin%2C%20professional%20aesthetician%2C%20warm%20candlelight&width=600&height=400&seq=bm_svc003&orientation=landscape",
  },
  {
    title: "Moroccan Bath",
    titleAr: "الحمام المغربي",
    href: "/services#moroccan-bath",
    image:
      "https://readdy.ai/api/search-image?query=luxury%20moroccan%20hammam%20bath%20spa%20treatment%2C%20woman%20relaxing%20in%20traditional%20moroccan%20steam%20bath%2C%20warm%20terracotta%20tiles%2C%20aromatic%20eucalyptus%20steam%2C%20gold%20lanterns%20and%20rose%20petals%2C%20premium%20spa%20experience%20beauty&width=600&height=400&seq=bm_svc007&orientation=landscape",
  },
  {
    title: "Eyelashes",
    titleAr: "تركيب الرموش",
    href: "/services#eyelashes",
    image:
      "https://readdy.ai/api/search-image?query=professional%20eyelash%20extension%20application%20close%20up%2C%20beautiful%20dramatic%20long%20lashes%20on%20woman%2C%20lash%20artist%20precision%20work%2C%20soft%20studio%20lighting%2C%20luxury%20beauty%20salon%20environment%2C%20stunning%20eye%20lash%20transformation&width=600&height=400&seq=bm_svc008&orientation=landscape",
  },
  {
    title: "Eyebrows",
    titleAr: "تصميم الحواجب",
    href: "/services#eyebrows",
    image:
      "https://readdy.ai/api/search-image?query=professional%20eyebrow%20shaping%20tinting%20henna%20brow%20treatment%20close%20up%2C%20perfectly%20shaped%20arched%20brows%20on%20beautiful%20woman%2C%20brow%20artist%20precision%20design%2C%20warm%20neutral%20background%2C%20luxury%20beauty%20salon&width=600&height=400&seq=bm_svc009&orientation=landscape",
  },
  {
    title: "Massage",
    titleAr: "خدمات المساج",
    href: "/services#massage",
    image:
      "https://readdy.ai/api/search-image?query=luxury%20spa%20massage%20treatment%2C%20woman%20relaxing%20during%20hot%20stone%20massage%20therapy%2C%20serene%20spa%20environment%2C%20candles%20and%20flowers%2C%20high-end%20wellness%20experience%20oman%20spa&width=600&height=400&seq=bm_svc005&orientation=landscape",
  },
  {
    title: "Waxing & Threading",
    titleAr: "إزالة الشعر والخيط",
    href: "/services#waxing",
    image:
      "https://readdy.ai/api/search-image?query=professional%20waxing%20and%20threading%20hair%20removal%20beauty%20treatment%2C%20clean%20modern%20beauty%20salon%2C%20soft%20warm%20lighting%2C%20precision%20beauty%20care%2C%20smooth%20skin%20result%2C%20luxury%20salon%20environment&width=600&height=400&seq=bm_svc004&orientation=landscape",
  },
  {
    title: "Makeup",
    titleAr: "خدمات المكياج",
    href: "/services#makeup",
    image:
      "https://readdy.ai/api/search-image?query=luxury%20professional%20makeup%20artist%20applying%20glamorous%20bridal%20makeup%2C%20beautiful%20middle%20eastern%20woman%2C%20elegant%20studio%20setting%2C%20soft%20warm%20golden%20lighting%2C%20high-end%20beauty%20transformation&width=600&height=400&seq=bm_svc006&orientation=landscape",
  },
];

export default function ServicesGrid() {
  return (
    <section id="services" className="py-16 sm:py-20 bg-[#f8f7f4]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-14">
          <p className="text-[#4a7fa5] text-xs tracking-[0.4em] uppercase mb-3 font-light">
            What We Offer / ما نقدمه
          </p>
          <h2
            className="text-[#1a2744] text-3xl sm:text-4xl font-light tracking-wide"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Our Services
          </h2>
          <p
            className="text-[#1a2744] text-2xl sm:text-3xl font-bold mt-1 tracking-wide"
            style={{ fontFamily: "'Noto Naskh Arabic', serif", direction: "rtl" }}
          >
            خدماتنا في صالون القمر الأزرق
          </p>
          <p
            className="text-[#1a2744]/60 text-sm mt-1 tracking-wide"
            style={{ fontFamily: "'Noto Naskh Arabic', serif", direction: "rtl" }}
          >
            خبراء في التجميل والعناية في الخوض، مسقط، سلطنة عمان
          </p>
          <p className="text-gray-400 text-sm mt-2 tracking-wide max-w-md mx-auto">
            Expert beauty &amp; wellness services in Al Koudh, Muscat, Oman
          </p>
        </div>

        {/* Desktop Grid: Large left (Hair) + 2x2 top right, then bottom row of 4 */}
        <div className="hidden md:block space-y-3">
          {/* Top section: large + 2x2 */}
          <div className="grid grid-cols-3 gap-3">
            {/* Large left - Hair Services */}
            <a
              href={services[0].href}
              className="relative overflow-hidden cursor-pointer group row-span-2 h-[440px]"
            >
              <img
                src={services[0].image}
                alt={`${services[0].title} - Blue Moon Beauty Salon Muscat`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-5 left-5">
                <span
                  className="text-white text-xl font-light tracking-widest uppercase"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  {services[0].title}
                </span>
                <p
                  className="text-white/70 text-sm mt-0.5"
                  style={{ fontFamily: "'Noto Naskh Arabic', serif" }}
                >
                  {services[0].titleAr}
                </p>
              </div>
            </a>

            {/* Right 2x2: items 1–4 */}
            <div className="col-span-2 grid grid-cols-2 gap-3">
              {services.slice(1, 5).map((svc) => (
                <a
                  key={svc.title}
                  href={svc.href}
                  className="relative overflow-hidden cursor-pointer group h-[212px]"
                >
                  <img
                    src={svc.image}
                    alt={`${svc.title} - Blue Moon Beauty Salon Muscat Oman`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                  <div className="absolute bottom-4 left-4">
                    <span
                      className="text-white text-base font-light tracking-widest uppercase"
                      style={{ fontFamily: "'Playfair Display', serif" }}
                    >
                      {svc.title}
                    </span>
                    <p
                      className="text-white/70 text-xs mt-0.5"
                      style={{ fontFamily: "'Noto Naskh Arabic', serif" }}
                    >
                      {svc.titleAr}
                    </p>
                  </div>
                </a>
              ))}
            </div>
          </div>

          {/* Bottom row: items 5–8 in 4 columns */}
          <div className="grid grid-cols-4 gap-3">
            {services.slice(5).map((svc) => (
              <a
                key={svc.title}
                href={svc.href}
                className="relative overflow-hidden cursor-pointer group h-[190px]"
              >
                <img
                  src={svc.image}
                  alt={`${svc.title} - Blue Moon Beauty Salon Muscat Oman`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-4 left-4">
                  <span
                    className="text-white text-sm font-light tracking-widest uppercase"
                    style={{ fontFamily: "'Playfair Display', serif" }}
                  >
                    {svc.title}
                  </span>
                  <p
                    className="text-white/70 text-xs mt-0.5"
                    style={{ fontFamily: "'Noto Naskh Arabic', serif" }}
                  >
                    {svc.titleAr}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>

        {/* Mobile Grid: 2-col */}
        <div className="md:hidden grid grid-cols-2 gap-3">
          {services.map((svc) => (
            <a
              key={svc.title}
              href={svc.href}
              className="relative overflow-hidden cursor-pointer group h-[160px]"
            >
              <img
                src={svc.image}
                alt={`${svc.title} - Blue Moon Beauty Salon`}
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-3 left-3">
                <span
                  className="text-white text-sm font-light tracking-wider uppercase"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  {svc.title}
                </span>
                <p
                  className="text-white/70 text-xs"
                  style={{ fontFamily: "'Noto Naskh Arabic', serif" }}
                >
                  {svc.titleAr}
                </p>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="/services"
            className="inline-flex items-center gap-2 cursor-pointer whitespace-nowrap border border-[#c6a864] text-[#c6a864] text-xs tracking-[0.2em] uppercase px-8 py-3.5 hover:bg-[#c6a864] hover:text-white transition-colors duration-300"
          >
            <i className="ri-list-check text-base"></i>
            <span>View All Services</span>
            <span className="opacity-80" style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>— كل خدماتنا</span>
          </a>
        </div>
      </div>
    </section>
  );
}
